import { render, staticRenderFns } from "./m_tiers_pj.vue?vue&type=template&id=62553fca"
import script from "./m_tiers_pj.vue?vue&type=script&lang=js"
export * from "./m_tiers_pj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports